// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"4360":"css/app.7006","5303":"css/admin-app.7006"}[chunkId] + ".css";
};